<template>
  <div
    class="card px-2 py-2 mt-3 wrapper-likedislike"
    v-if="likeDislikeData.length > 0"
  >
    <div>
      <button class="btn" style="box-shadow: none;" @click="visible = !visible">
        <i class="fas fa-thumbs-up"></i>
        {{ this.$t('reports.likeDislikeGroup.likeDislikeLabel') }}
      </button>
      <button
        class="btn pull-right"
        style="box-shadow: none;"
        @click="visible = !visible"
      >
        <i class="fas fa-angle-double-right" v-if="!visible"></i>
        <i v-else class="fas fa-angle-double-down"></i>
      </button>
    </div>
    <div class="wrapper-rankings card" v-if="loader">
      <div>
        <div class="loader d-flex justify-content-center align-items-center">
          <b-spinner
            variant="primary"
            type="grow"
            :label="`${this.$t('reports.loadingLabel')}...`"
          ></b-spinner>
        </div>
      </div>
    </div>
    <div v-else>
      <b-collapse v-model="visible" class="mt-2">
        <b-table :items="items" :fields="fields" caption-bottom sort-icon-left>
          <template v-slot:cell(question)="row">
            <div style="max-width: 80%;">
              {{ row.item.question }}
            </div>
          </template>
          <template v-slot:cell(score)="row">
            <div class="text-center">
              {{ row.item.score }}
            </div>
          </template>
          <template v-slot:cell(scoreGroup)="row">
            <div class="text-center">
              {{ row.item.scoreGroup }}
            </div>
          </template>
          <template v-slot:cell(scoreGeral)="row">
            <div class="text-center">
              {{ row.item.scoreGeral }}
            </div>
          </template>
        </b-table>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import api from '@/services/api';
import EventBus from '../../../../../../eventBus';

export default {
  name: 'LikeDislikeGroup',
  props: ['showCollapsed', 'selectedBranch', 'selectedGroup'],
  data: () => ({
    isBusy: false,
    filter: null,
    userAuth: null,
    visible: true,
    total: 0,
    page: 1,
    limit: 10,
    items: [],
    loader: false,
    likeDislikeData: [],
    fields: [],
  }),
  watch: {
    actionGroupData: function watchActionGroupData() {
      this.mountLikeDislike();
    },
    myActionId: function watchMyActionId() {
      this.mountLikeDislike();
    },
    myActionsIds: function watchMyActionsIds() {
      this.mountLikeDislike();
    },
    myIh1: function watchMyIh1() {
      this.mountLikeDislike();
    },
    myHierarchies1: function watchMyHierarchies1() {
      this.mountLikeDislike();
    },
    myIh2: function watchMyIh2() {
      this.mountLikeDislike();
    },
    myHierarchies2: function watchMyHierarchies2() {
      this.mountLikeDislike();
    },
    calendarDates: function watchDates() {
      this.mountLikeDislike();
    },
    myMetric: function watchMyMetric() {
      this.mountLikeDislike();
    },
    'indicatorData.value': function watchMyMetric() {
      this.mountLikeDislike();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.mountLikeDislike();
    },
  },
  computed: {
    ...mapState('charts', ['filterRankings']),
    ...mapState('actions', ['myActionId', 'myActionsIds', 'actionGroupData']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },
  methods: {
    async mountLikeDislike() {
      this.loader = true;
      const response = await api.get(`reports/get-like-dislike-group`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          filter: this.filterRankings ? this.filterRankings : null,
          companyId: this.userAuth.companyId,
          actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
          startDate: this.calendarDates.start ? this.calendarDates.start : null,
          endDate: this.calendarDates.end ? this.calendarDates.end : null,
          ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
          ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
          metric: this.myMetric ? this.myMetric : null,
          groupId: this.actionGroupData._id,
          indicator: this.indicatorName,
          indicatorValue: this.indicatorData.value,
          indicatorRange: this.indicatorData.range,
          selectedBranch: this.selectedBranch,
          selectedGroup: this.selectedGroup,
        },
      });
      this.likeDislikeData = response.data;
      this.items = [];
      this.likeDislikeData.map((obj) => {
        this.items.push({
          question: obj.question,
          progress: obj.percentil,
          score: obj.averageAllBranches,
          scoreBranch: obj.averageBranch,
          scoreGroup: obj.averageGroup,
          total: obj.totalAllBranches,
        });
      });
      this.loader = false;
    },
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.fields = [
      {
        key: 'question',
        label: this.$t('reports.likeDislikeGroup.addQuestionLabel'),
        sortable: true,
        class: 'questionTh',
      },
      {
        key: 'scoreBranch',
        label: this.$t('reports.likeDislikeGroup.branchLabel'),
        sortable: true,
        class: 'scoreTh',
      },
      {
        key: 'scoreGroup',
        label: this.$t('reports.likeDislikeGroup.groupLabel'),
        sortable: true,
        class: 'scoreTh',
      },
      {
        key: 'score',
        label: this.$t('reports.likeDislikeGroup.companyLabel'),
        sortable: true,
        class: 'scoreTh',
      },
    ];
  },
  mounted() {
    this.visible = !this.showCollapsed;
    this.mountLikeDislike();
    EventBus.$on('filter-rankings', () => {
      this.mountLikeDislike();
    });
  },
};
</script>

<style scoped lang="scss">
.no-padding {
  padding: 0;
}
.table {
  margin: 0;
}
.wrapper-likedislike .table > thead > tr:nth-child(2) {
  display: none;
}
.wrapper-likedislike .btn .btn-light .collapsed {
  background-color: transparent;
}
.progress-info {
  font-size: 12px;
  display: ruby-text;
}
.f-left {
  float: left;
}
.f-right {
  float: right;
}
.likesTh {
  padding-right: 0px !important;
  padding-top: 5px !important;
  font-size: 12px;
}
.dislikesTh {
  padding-left: 0px !important;
  padding-top: 5px !important;
  font-size: 12px;
}
.progress {
  background-color: #d62027;
}
.likeColor {
  color: #4ce595;
}
.dislikeColor {
  color: #d62027;
}
.wrapper-rankings.card {
  min-height: 200px;
}
.wrapper-rankings .loader {
  min-height: 200px;
}
.card {
  border: 1px solid rgba(0, 0, 0, 0.09);
}
.form {
  display: grid;
  position: absolute;
  width: 185px;
  right: 155px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/reports/rankings/components/like-dislike-group.vue